var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitStep3Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_4365)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -5,
    width: 140,
    height: 140,
    rx: 33.1797,
    fill: "#FF6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9565 130.9C47.9165 130.9 30.4365 117.6 24.5465 106.77L35.1865 98.22C39.7465 106.2 51.9065 117.41 70.7165 117.41C90.2865 117.41 102.447 103.54 102.447 89.86C102.447 77.13 91.9965 66.3 75.4665 66.3H63.3065L66.3465 52.43H81.9265C97.8865 52.43 110.807 43.69 110.807 28.3C110.807 14.62 98.8365 7.58999 85.7265 7.58999C73.7565 7.58999 63.3065 12.53 55.8965 18.99L48.1065 8.73C57.6065 0.559989 70.5265 -5.90001 87.2465 -5.90001C107.957 -5.90001 125.057 7.20999 125.057 26.97C125.057 47.11 108.147 58.51 97.1265 60.6C106.247 64.21 116.697 74.09 116.697 89.48C116.697 111.52 96.7465 130.9 69.9565 130.9Z",
    fill: "#FFFAF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_4365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 33.18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitStep3Light);
export default __webpack_public_path__ + "static/media/digit_step_3_light.146e1be2cc0e1c8728b06eadac53789c.svg";
export { ForwardRef as ReactComponent };